import { GlobeIcon } from '@flywire/icons';
import {
  hideLanguageSelectorView,
  showLanguageSelectorView,
} from 'actions/ui/ui';
import { useSelector } from 'react-redux';
import { getCurrentLocale } from 'selectors';
import { getIsLanguageSelectorViewVisible } from 'selectors/ui/ui';
import { useDispatch } from 'store/configureStore';
import { useTranslations } from 'utils';

type LanguageToggleProps = {
  onClick?: () => void;
};

export const LanguageToggle = ({ onClick }: LanguageToggleProps) => {
  const i18n = useTranslations();
  const dispatch = useDispatch();
  const locale = useSelector(getCurrentLocale);
  const isLanguageSelectorViewVisible = useSelector(
    getIsLanguageSelectorViewVisible,
  );

  const handleClick = () => {
    if (isLanguageSelectorViewVisible) {
      dispatch(hideLanguageSelectorView());
    } else {
      dispatch(showLanguageSelectorView());
    }
    onClick?.();
  };

  return (
    <button
      className="flex items-center gap-2 text-sm cursor-pointer bg-transparent border-none p-1 text-white focus-visible:outline-1 focus-visible:outline-offset-2 focus-visible:outline-white rounded"
      onClick={handleClick}
      aria-label={String(i18n.t('languageSelector.changeLanguage'))}
    >
      <GlobeIcon className="size-4" />
      {i18n.t(`locales.${locale}`)}
    </button>
  );
};
